export default "__VITE_ASSET__C0r9qqkG__"